<template>
  <div class="containerTable">
    <vxe-table
      ref="xTable"
      border
      resizable
      highlight-current-row
      highlight-hover-row
      row-id="id_payFlow"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" />

      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="isPayAdvance"
          title="运费类型"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'isPayAdvance')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isPayAdvance"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.isPayAdvanceOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="isSendFund"
          title="上报状态"
          :formatter="formatterSendFundStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isSendFund"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in sendFundOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="payType"
          title="支付类型"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'payType')
          "
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.payType" placeholder="请选择" clearable>
            <el-option
              v-for="item in parentData.payTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <!-- 车队是否清分 暂无此字段 -->
      <vxe-table-column>
        <vxe-table-column
          field="isShare"
          title="车队是否清分"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'isShare')
          "
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.isShare" placeholder="请选择" clearable>
            <el-option
              v-for="item in parentData.isShareOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderDetailNumber"
          title="运单号"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderDetailNumber"
            placeholder="请输入运单号"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="orderNo"
          title="流水批次号"
          min-width="264"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderNo"
            placeholder="请输入流水批次号"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="amount"
          title="金额（元）"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.amountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.amountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="payerName"
          title="付款方名称"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payerName"
            placeholder="请输入付款方名称"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="payerAccount"
          title="付款方账号(商户)"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payerAccount"
            placeholder="请输入付款方账号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payerPhone"
          title="付款方电话"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payerPhone"
            placeholder="请输入付款方电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payerRole"
          title="付款方角色"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'payerRole')
          "
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.payerRole"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.payerRoleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payeeName"
          title="收款方名称"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payeeName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payeeAccount"
          title="收款方账号(商户)"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payeeAccount"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payeePhone"
          title="收款方电话"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payeePhone"
            type="number"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="payeeRole"
          title="收款方角色"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'payeeRole')
          "
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.payeeRole"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.payeeRoleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="callbackTime"
          title="完成时间"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="value"
            type="datetimerange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            @change="dataPicker"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="value2"
            type="datetimerange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            @change="dataPicker2"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="modifiedByName"
          title="操作人员"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.modifiedByName"
            placeholder="请输入操作人员"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column field="payReceiptImg" title="支付凭证" min-width="150">
        <template v-slot="{row}">
          <div v-if="row.payType == '5' ||row.payType == '4'||row.payType == '9'||row.payType == '10'">
            <el-button @click="lookReceipt(row)">查看电子回单</el-button>
          </div>
          <div v-else>
            <el-image
              style="height:40px;"
              :src="row.payReceiptImg"
              :preview-src-list="[row.payReceiptImg]"
            >
              <div slot="error" class="image-slot" />
            </el-image>
          </div>
        </template>
      </vxe-table-column> -->
      <vxe-table-column title="操作" width="160px" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="
              getLimit('payFlow_edit_button') &&
                scope.row.isSendFund == '0' &&
                scope.row.payType == '3'
            "
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button type="text" @click="funcEdit(scope.row.code, false)">
              <em class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('payFlow_detail_button') && scope.row.isPayAdvance !== 2
            "
            class="item"
            effect="dark"
            content="运单详情"
            placement="top"
          >
            <!-- <vxe-button type="text" @click="funcEdit(scope.row.code,true)">
              <em class="el-icon-document" />
            </vxe-button> -->
            <vxe-button
              type="text"
              @click="orderDesil(scope.row.orderDetailCode)"
              ><em class="el-icon-document"
            /></vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('payFlow_receipt_button') &&
                scope.row.payType !== 1 &&
                scope.row.payType !== 2
            "
            class="item"
            effect="dark"
            content="回单"
            placement="top"
          >
            <vxe-button type="text" @click="lookReceipt(scope.row)">
              <em class="el-icon-paperclip" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelEditFlag"
      :title="titleFlag ? '详情' : '编辑'"
      width="800"
      height="740"
      resize
      :transfer="true"
    >
      <!-- {{ titleFlag }} -->
      <compEdit
        ref="editRef"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="tuteship"
      title="运输单详情"
      width="1000"
      height="80%"
      resize
      :transfer="true"
    >
      <ordergoods ref="detailRef" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compEdit from "@/views/tms/AccountManagement/payFlow/components/remitDefiniteForPayEdit.vue";
import { electronicReceipt } from "@/api/InternetBanking";
import request from "@/utils/request";
import { getListDict } from "@/api/commonApi";
import ordergoods from "@/components/WaybillDetails";
export default {
  name: "PayFlowList",
  components: {
    compEdit,
    ordergoods
  },
  data() {
    return {
      titleFlag: false,
      callbackTimeRange: "",
      loading: false,
      exportObj: {
        exportUrl: "/ntocc-tms-api/remitDefinite/exportPaymentFlow", //导出接口
        name: "支付流水"
      },
      tableData: [],
      dialogTableVisible: false,
      ModelCashMoney: false,
      showElectronicReceiptFlag: false,
      showElectronicReceiptUrl: "",
      modelEditFlag: false,
      modelDetailFlag: false,
      errorData: [],
      parentData: {},
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        sortField: "",
        sortType: "",
        total: 0,
        notPayType: "6",
        payType: ""
      },
      accdata: [],
      // 机构列表
      branchList: this.$store.state.components.branchList,
      sendFundOptions: [
        { value: "0", label: "未上报" },
        { value: "1", label: "已上报" },
        { value: "2", label: "上报失败" }
      ],
      payFlow_search_button: false,
      payFlow_edit_button: false,
      payFlow_export_button: false,

      value: "",
      value2: "",
      bankList: [],
      tuteship: false
    };
  },
  created() {
    this.parentData.isPayAdvanceOptions = [
      { label: "结算运费", value: 0 },
      { label: "预付运费", value: 1 },
      { label: "充值运费", value: 2 }
    ];
    (this.parentData.payTypeOptions = [
      { label: "油点支付", value: 1 },
      { label: "转账支付", value: 3 },
      { label: "网商余额", value: 4 },
      { label: "网商合并", value: 5 },
      { label: "车队分账", value: 6 },
      { label: "凭证支付", value: 9 },
      { label: "银行支付", value: 10 },
      { label: "在线支付", value: 11 }
    ]),
      (this.parentData.isShareOptions = [
        { label: "否", value: 0 },
        { label: "是", value: 1 }
      ]),
      (this.parentData.payerRoleOptions = [
        { label: "平台", value: 0 },
        { label: "个体托运人", value: 1 },
        { label: "企业托运人", value: 2 },
        { label: "实际承运人", value: 3 }
      ]),
      (this.parentData.payeeRoleOptions = [
        { label: "平台", value: 0 },
        { label: "个体托运人", value: 1 },
        { label: "企业托运人", value: 2 },
        { label: "个体实际承运人", value: 3 },
        { label: "车队", value: 4 }
      ]),
      // 获取数据字典： 银行
      getListDict({ types: "bank" }).then(response => {
        this.bankList = response.data.filter(item => item.type === "bank")[0][
          "dictList"
        ];
      });
    this.payFlow_search_button = this.getLimit("payFlow_search_button");
    this.payFlow_edit_button = this.getLimit("payFlow_edit_button");
    this.payFlow_export_button = this.getLimit("payFlow_export_button");
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return request({
        url: "/ntocc-tms-api/remitDefinite/queryListForPay",
        method: "get",
        params: this.listQuery
      }).then(response => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        this.loading = false;
      });
    },
    // 查询
    funcFilter() {
      this.listQuery.pageNum = 1;
      this.findList();
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item1 => item1.code === cellValue);
      return item ? item.groupName : "";
    },
    // 排序
    sortList({ column, property, order }) {
      if (order) {
        this.listQuery.sortField = property;
        this.listQuery.sortType = order;
      } else {
        this.listQuery.sortField = "";
      }
      this.findList();
    },
    // 翻译
    formatterField({ cellValue }, prefix) {
      const item = this.parentData[`${prefix}Options`].find(
        item1 => item1.value === cellValue
      );
      return item ? item.label : "";
    },
    // 时间
    changeDate(value, prefix) {
      if (value) {
        this.listQuery[`${prefix}Start`] = value[0] + " 00:00:00";
        this.listQuery[`${prefix}End`] = value[1] + " 23:59:59";
      } else {
        this.listQuery[`${prefix}Start`] = "";
        this.listQuery[`${prefix}End`] = "";
      }
    },
    // 修改方法
    funcEdit(code, flag) {
      this.$refs.editRef.getInfo(code, flag);
      this.modelEditFlag = true;
      this.titleFlag = flag;
    },
    orderDesil(c) {
      this.$refs.detailRef.Getdetails(c);
      this.tuteship = true;
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false;
      this.findList();
    },
    lookReceipt(row) {
      if (row.code) {
        electronicReceipt({ code: row.code }).then(res => {
          let url = res.data;
          if (url) {
            window.open(url, "_blank");
          } else {
            return this.$message({ message: "暂无回单", type: "warning" });
          }
        });
      } else {
        return this.$message({ message: "暂无回单", type: "warning" });
      }
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "edit":
          this.modelEditFlag = false;
          break;
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
    },
    formatterSendFundStatus({ cellValue }) {
      let item = this.sendFundOptions.find(item1 => item1.value == cellValue);
      return item == null ? "" : item.label;
    },
    // 创建时间
    dataPicker2(value) {
      if (value) {
        this.listQuery.gmtCreatedStart = value[0];
        this.listQuery.gmtCreatedEnd = value[1];
      } else {
        this.listQuery.gmtCreatedStart = "";
        this.listQuery.gmtCreatedEnd = "";
      }
    },
    // 到账时间
    dataPicker(value) {
      if (value) {
        this.listQuery.callbackTimeStart = value[0];
        this.listQuery.callbackTimeEnd = value[1];
      } else {
        this.listQuery.callbackTimeStart = "";
        this.listQuery.callbackTimeEnd = "";
      }
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    }
  }
};
</script>

<style lang="scss" scoped>
.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
</style>
